// 倒计时
function getRandomNum(min, max) {
	return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
	let nowTime = new Date();
	let endTime = new Date(endTimeG);

	let leftTime = endTime.getTime() - nowTime.getTime();
	if (leftTime < 0) {
		setupNewCountdown();
		leftTime = 0;
	}
	let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
		leftM = Math.floor((leftTime / (1000 * 60)) % 60),
		leftS = Math.floor((leftTime / 1000) % 60);
	leftH = leftH >= 10 ? leftH : "0" + leftH;
	leftM = leftM >= 10 ? leftM : "0" + leftM;
	leftS = leftS >= 10 ? leftS : "0" + leftS;

	return {
		hour: leftH,
		minute: leftM,
		second: leftS,
	};
}
function setupNewCountdown() {
	const randomHour = getRandomNum(1, 9);
	const currentTime = new Date();
	endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
	setupNewCountdown();
	if (intervalId) clearInterval(intervalId);
	intervalId = setInterval(function () {
		let cutDownTimeText = cutDownTime();
		$(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
		$(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
		$(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
	}, 1000);
}

getCutDownTime();

function mainRender() {
	$(function () {
		$("#root").css("zoom", "normal");
		let scale = document.body.clientWidth / 1080;
		$("#root").css("zoom", scale);

		window.addEventListener(
			"resize",
			(function () {
				var timer;
				return function () {
					if (timer) clearTimeout(timer);
					timer = setTimeout(function () {
						$("#root").css("zoom", "normal");
						let scale = document.body.clientWidth / 1080;
						$("#root").css("zoom", scale);
					}, 100);
				};
			})()
		);
	});

	function lazyLoadImages() {
		// 懒加载
		const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
		const config = {
			rootMargin: "0px 0px 1300px 0px",
			threshold: 0,
		};

		const lazyLoadObserver = new IntersectionObserver(function (
			entries,
			observer
		) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					// 当图片进入视口时
					const image = entry.target;
					const dataSrc = image.getAttribute("data-src");
					image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
					lazyLoadObserver.unobserve(image); // 停止观察该图片
				}
			});
		},
		config);

		images.forEach(function (image) {
			lazyLoadObserver.observe(image); // 开始观察每个图片
		});
	}

	function preloadImages(imageArray) {
		// 预加载
		// 检查数组数据结构
		if (Array.isArray(imageArray[0])) {
			// 处理二维数组
			imageArray.forEach((subArray) => {
				subArray.forEach((url) => {
					const img = new Image();
					img.src = url;
				});
			});
		} else {
			// 处理一维数组
			imageArray.forEach((url) => {
				const img = new Image();
				img.src = url;
			});
		}
	}

	// new Swiper(".sp-swiper1", {
	// 	autoplay: {
	// 		disableOnInteraction: false,
	// 		delay: 250000,
	// 	},
	// 	spaceBetween: 0,
	// 	slidesPerView: "auto",
	// 	centeredSlides: true,
	// 	loop: true,
	// });

	new Swiper("#sp-swiper2", {
		autoplay: {
			disableOnInteraction: false,
			delay: 2500,
		},
		spaceBetween: 0,
		slidesPerView: "auto",
		centeredSlides: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	// 初始化 Swiper 并保存实例引用
	const spSwiper3 = new Swiper(".sp-swiper3", {
		allowTouchMove: false,
		autoplay: false,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		noSwiping: true,
		simulateTouch: false,
		resistanceRatio: 0,
		preventInteractionOnTransition: true,
		loop: true,
	});

  let spprev = document.querySelector(".sp-swiper-btn-prev");
  let spnext = document.querySelector(".sp-swiper-btn-next");
  spnext.addEventListener("click", function () {
    let items = document.querySelectorAll(".sp-swiper-item");
    document.querySelector(".sp-swiper-box").appendChild(items[0]);
    spSwiper3.slideNext();
  });
  spprev.addEventListener("click", function () {
    let items = document.querySelectorAll(".sp-swiper-item");
    document.querySelector(".sp-swiper-box").prepend(items[items.length - 1]);
    spSwiper3.slidePrev();
  });

	$(".reduce").click(function () {
		let input = $(this).siblings("input")[0];
		let num = Number(input.value) - 1;
		if (num > 0) {
			input.value = num;
		}
	});
	$(".add").click(function () {
		let input = $(this).siblings("input")[0];
		let num = Number(input.value) + 1;
		input.value = num;
	});
  $('.sp-btn-style').click(function(){
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? num = 1 : ''
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })

	document.addEventListener("DOMContentLoaded", function () {
		lazyLoadImages();

		// 找到所有跳转套餐的锚点链接
		var links = document.querySelectorAll('a[href^="#shopping"]');
		links.forEach(function (link) {
			link.addEventListener("click", function (event) {
				event.preventDefault(); // 阻止默认的跳转行为
				// var targetElement = document.getElementById('shopping');
				// if (targetElement) {
				//     targetElement.scrollIntoView({ behavior: 'smooth' });
				// } // 方式一
				const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
				const offsetTop = targetElement.offsetTop;
				window.scroll({
					top:
						offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
					behavior: "smooth", // 使用 smooth 实现平滑滚动
				}); // 方式二
			});
		});
	});

	// IOS字体多了间距的处理 给节点添加 sp_system 类名
	// 判断当前用户是安卓端还是iOS端
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	var isAndroid = /android/i.test(userAgent);
	var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
	var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

	if (isAndroid) {
		console.log("Android");
	} else if (isIOS) {
		console.log("iOS");
	} else if (isPC) {
		console.log("PC");
	} else {
		$(".sp_system").css("letter-spacing", "-4px");
	}

	$(".sp-large,.p-img").click(function () {
		let index = $(".swiper-p2 .swiper-slide-active").index();
		if (index == 6) {
			$(".sp-mask .sp-img").css("width", "110%");
		} else {
			$(".sp-mask .sp-img").css("width", "180%");
		}
		$(".sp-mask .sp-size-content").hide();
		$(".sp-mask .sp-img").show();
		$(".sp-mask").css("display", "flex");
		let img = $(".swiper-p2 .swiper-slide-active img").attr("src");
		$(".sp-mask .sp-img")[0].src = img;
	});

	// 展示尺码弹窗
	$(".size-guide").click(function () {
		$(".sp-mask .sp-img").hide();
		$(".sp-mask .sp-size-content").show();
		$(".sp-mask").css("display", "flex");
		$(".sp-mask .size-pop").show();
		$(".sp-mask .img-pop").hide();
	});

	// 关闭弹窗按钮
	$(".sp-mask").click(function (e) {
		if ($(e.target).closest(".sp-mask .choose-btn").length > 0) {
		} else {
			$(".sp-mask").hide();
		}
	});

	// const tabs = $(".sp-tab");

	// let currentIndex = 0; // 当前展示的tab索引

	// function nextTabFunc() {
	// 	const currentTab = tabs[currentIndex];
	// 	// 当前tab开始动画
	// 	currentTab.classList.add("sp-tab-ani");

	// 	let nextIndex = (currentIndex + 1) % tabs.length;
	// 	const nextTab = tabs[nextIndex];

	// 	setTimeout(() => {
	// 		currentTab.classList.remove("sp-tab-ani");
	// 	}, 2500);

	// 	currentIndex = (currentIndex + 1) % tabs.length;
	// 	setTimeout(nextTabFunc, 1500);
	// }

	// nextTabFunc();



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
}

mainRender();
